import { DebounceInput } from "react-debounce-input";
import { InputWrapper, SearchBorder, Wrapper } from "./SearchBar.styles";
import { Loading } from "../Loaders/Loading";
import { getCategoryBySlug } from "../../../lib/helpers/category";
import { useLocation, useParams } from "react-router-dom";
import Icon, { Icons } from "react-hp-icons";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import queryString from "query-string";

interface Props {
	searchValue?: string;
	setSearch(string): void;
	category: any;
}

const SearchBar = ({ search, setSearch }: Props) => {
	const location = useLocation();
	const defaultPlaceholder = "Busca un local...";
	const [placeholder, setPlaceholder] = useState(defaultPlaceholder);
	const [state] = useGlobal();
	const { search: searchState } = state;
	const queryParams = queryString.parse(location.search, {
		parseBooleans: true,
	});
	const { all: queryAll } = queryParams;
	const setSearchValue = useDispatch("setSearchValue");
	const isInSearchResults = !!location.search;

	const handlePlaceholder = () => {
		if (!!searchState.category.name && !queryAll && !!location.search) {
			const categoryPlaceholder = `Buscar en ${searchState.category.name}...`;
			setPlaceholder(categoryPlaceholder);
		} else {
			setPlaceholder(defaultPlaceholder);
		}
		setSearch("");
	};

	useEffect(() => {
		handlePlaceholder();
	}, [location.pathname, location.search]);

	return (
		<Wrapper>
			<SearchBorder>
				<>
					<Icon type={Icons.search} size={1.4} />
					<InputWrapper>
						<DebounceInput
							value={search}
							placeholder={placeholder}
							minLength={3}
							debounceTimeout={(isInSearchResults && 1000) || 100}
							onChange={(e) => {
								const searchValue = e.target.value
									.trim()
									.toLowerCase();
								setSearch(searchValue);
								if (isInSearchResults) {
									setSearchValue(searchValue);
								}
							}}
						/>
					</InputWrapper>
				</>
			</SearchBorder>
		</Wrapper>
	);
};

export default SearchBar;
